
import { Directive, HostListener, HostBinding, Input } from '@angular/core';
import { CmsService } from 'src/app/services/cms.service';
import { Store } from 'src/app/store';

@Directive({
  selector: 'img[default]',
})
export class MissingImageUrlDirective {

  @HostBinding('src')
  @Input()
  src: any;
   setting = this.store.selectForLocal('settings');
  constructor(private cmsService: CmsService,private store:Store) {
  }
 
  @HostListener('error')
  onError() {
    this.src = this.setting.missingImageUrl;
  }
}